import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/50_halloween_still_life/50_halloween_still_life"
 * Contains 1 texture(s)
 */
export class Tablet50HalloweenStillLifeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/50_halloween_still_life/50_halloween_still_life';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '50_halloween_still_life.jpg'
    ] as const;
}
